import { AccountOfflineService } from './../../../../services/account/account.offline.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';
import { MdmService } from '@omni/services/mdm/mdm.service';
import {NavigationService, PageName} from "@omni/services/navigation/navigation.service";
import {DeviceService} from "@omni/services/device/device.service";
import {UIService} from "@omni/services/ui/ui.service";
import { NavParams } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { SharedModule } from "../../../../shared/shared.module";


@Component({
  standalone: true,
  imports: [SharedModule],
  selector: 'account-cr',
  templateUrl: 'account-cr.html',
  styleUrls: ['account-cr.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountCrComponent {

  @Input() source: any[];
  public selected: any = null;

  constructor(
    public mdmService: MdmService,
    private navService: NavigationService,
    private device: DeviceService,
    private uiService: UIService,
    public translate: TranslateService,
    public navParams: NavParams,
    private accountService: AccountOfflineService,
    private readonly datePipe: DatePipe,
    private readonly _cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    if (this.navParams && this.navParams.data && this.navParams.get('openedToolFromCrDetails') && this.navParams.get('openedToolFromCrDetails') === true) {
      const selectedAccountCr = this.accountService.selectedAccountCr;
      if (selectedAccountCr) this.viewDetails(selectedAccountCr);
      this.accountService.selectedAccountCr = '';
    }
  }

  async viewDetails(selected) {
    let currentData;
    if (this.device.isOffline) {
      currentData = selected;
    }
    else {
      try {
        await this.uiService.displayLoader();
        await this.mdmService.fetchAccountCRConfiguredDisplay(false, false, selected).then((res) => {
          if (res && Array.isArray(res)) {
            currentData = res[0];
          }
          else {
            currentData = res;
          }
          this.uiService.dismissLoader();
        });

      }catch (e) {
        await this.uiService.dismissLoader();
      }
    }
    this.selected = currentData;
    this.mdmService.currentSelected.next(currentData);
    this._cd.markForCheck();
    this.navService.setChildNavRightPaneView(true);
    this.uiService.showNewActivity = false;
    await this.navService.pushChildNavPageWithPageTracking(PageName.AccountCrDetailsComponent, PageName.AccountCrDetailsComponent, PageName.AccountPageComponent, {
      from: 'Account'
    });
  }

  getDisplayDate(value): string {
    return this.datePipe.transform(value, 'MMM dd yyyy', undefined, this.translate.currentLang);
  }

  public trackByAccountCrId(index: number, item: any): string {
    return item?.indskr_accountcrid ?? index.toString();
  }
}
